import mergeByProp from '../../../lib/mergeByProp.js';
import formatLead from '../../lib/formatLead.js';
import sortByProp from '../../../lib/sortByProp';

const currentServiceProviderReducerLeadsSlice = {
  GET_PIPELINE_LEADS_SUCCESS: (state, payload) => {
    const pipelineLeads = (payload.data || []).map((n) => ({ ...n, sub_status_id: n.sub_status_id || '3' }));
    const leads = pipelineLeads.map((n) => n.lead).filter((n) => (n || {}).id);
    return {
      ...state,
      leads: mergeByProp('id', state.leads, leads, (stateLead, newLead) => ({
        ...stateLead,
        meta: newLead.meta || stateLead.meta,
        stats: newLead.stats || stateLead.stats,
      })),
      pipelineLeads: mergeByProp('id', state.pipelineLeads, pipelineLeads).sort(sortByProp('id')),
    };
  },

  POST_PIPELINE_LEAD_SUCCESS: (state, payload) => {
    return {
      ...state,
      leads: mergeByProp('id', state.leads, [formatLead(payload.data.lead)]),
      pipelineLeads: mergeByProp('id', state.pipelineLeads, [payload.data]),
    };
  },

  PUT_PIPELINE_LEAD_SUCCESS: (state, payload) => {
    return !payload.data.id
      ? { ...state }
      : {
          ...state,
          pipelineLeads: mergeByProp('id', state.pipelineLeads, [{ ...payload.data }]),
        };
  },

  DELETE_PIPELINE_LEAD_SUCCESS: (state, payload) => ({
    ...state,
    pipelineLeads: (state.pipelineLeads || []).filter((n) => n.id !== payload.data.id),
  }),

  POST_GENERIC_INTEGRATION_SUCCESS: (state, payload) => {
    return {
      ...state,
      leads: mergeByProp('id', state.leads, [formatLead(payload.data)]),
    };
  },

  POST_COMPOSER_MESSAGE_SUCCESS: (state, payload) => {
    if (!(payload.data || {}).lead_id) {
      return state;
    }

    const messageType = payload.data.todo_type || payload.data.todo_status ? 'todos' : payload.data.type;

    if (messageType === 'todos') {
      return {
        ...state,
        todos: mergeByProp('id', state.todos, [{ ...payload.data, overdue: payload.data.todo_status === '1' ? true : undefined }]),
        leads: state.leads.map((n) =>
          n.id !== payload.data.lead_id
            ? n
            : {
                ...n,
                todos: (n.todos || []).concat({ ...payload.data }),
              }
        ),
      };
    }

    if (['emails', 'texts'].includes(messageType)) {
      const lastOutgoingKey = {
        emails: 'last_outgoing_email_date',
        texts: 'last_outgoing_text_date',
      }[payload.data.type];
      return {
        ...state,
        leads: state.leads.map((n) =>
          n.id !== payload.data.lead_id
            ? n
            : {
                ...n,
                meta: {
                  ...n.meta,
                  [lastOutgoingKey]: {
                    ...((n.meta || {})[lastOutgoingKey] || {}),
                    value: payload.data.event_date,
                  },
                },
              }
        ),
      };
    }

    if (messageType === 'notes') {
      return {
        ...state,
        leads: state.leads.map((n) =>
          n.id !== payload.data.lead_id
            ? n
            : {
                ...n,
                notes: [payload.data, ...(n.notes || [])],
              }
        ),
      };
    }

    return state;
  },

  PATCH_PIPELINE_LEAD_STATUS_SUCCESS: (state, payload) => ({
    ...state,
    pipelineLeads: mergeByProp('id', state.pipelineLeads, [{ ...payload.data }]).sort(sortByProp('id')),
  }),

  GET_UPDATED_PIPELINE_LEAD_EVENT: (state, payload) => ({
    ...state,
    pipelineLeads: mergeByProp('id', state.pipelineLeads, [{ ...payload.event.pipeline_lead }]).sort(sortByProp('id')),
  }),

  POST_PHONE_CALL_SUCCESS: (state, payload) => {
    if (!payload.data) {
      return { ...state };
    }
    return {
      ...state,
      leads: state.leads.map((n) =>
        n.id !== payload.data.lead_id
          ? n
          : {
              ...n,
              meta: {
                ...n.meta,
                ['last_outgoing_call_date']: {
                  ...((n.meta || {})['last_outgoing_call_date'] || {}),
                  value: payload.data.event_date,
                },
              },
            }
      ),
    };
  },

  GET_LEAD_SUCCESS: (state, payload) => {
    const pipelineLeads = payload.data.pipeline_leads || [];
    const lead = formatLead({ ...payload.data });
    return {
      ...state,
      todos: [...state.todos, ...lead.todos.filter((n) => !state.todos.find((o) => o.id === n.id))],
      leads: mergeByProp('id', state.leads, [lead]),
      pipelineLeads: mergeByProp('id', state.pipelineLeads, pipelineLeads).sort(sortByProp('id')),
    };
  },

  GET_UPDATED_LEAD_EVENT: (state, payload) => ({
    ...state,
    leads: mergeByProp('id', state.leads, [formatLead({ ...payload.event.lead })], (stateLead, newLead) => ({
      ...newLead,
      ...stateLead,
      meta: newLead.meta || stateLead.meta,
      stats: newLead.stats || stateLead.stats,
    })),
  }),

  PUT_SERVICE_INTEREST_SUCCESS: (state, payload) => {
    if ((payload.data || []).length) {
      const pipelineLeadId = (payload.data.find((n) => n.pipeline_lead_id) || {}).pipeline_lead_id;
      return {
        ...state,
        pipelineLeads: state.pipelineLeads.map((n) => (n.id !== pipelineLeadId ? n : { ...n, service_interests: payload.data })),
      };
    }
    return {
      ...state,
    };
  },

  DELETE_SERVICE_INTEREST: (state, payload) => ({
    ...state,
    pipelineLeads: state.pipelineLeads.map((n) => (n.id !== payload.pipelineLeadId ? n : { ...n, service_interests: n.service_interests.filter((o) => o.id !== payload.id) })),
  }),

  PIPELINE_LEAD_STAGE_CHANGE_LOCAL: (state, payload) => ({
    ...state,
    pipelineLeads: state.pipelineLeads.map((n) => (n.id !== payload.draggableId ? n : { ...n, stage_id: payload.destination.droppableId })),
  }),
};

export default currentServiceProviderReducerLeadsSlice;
